import moment from 'moment';

import { TrendMixReportViewModel } from 'api/backofficeApiClient';

const getDynamicColumnsReportFormattedValues = (
  reportData: TrendMixReportViewModel,
) => {
  const items = reportData.items?.map((value) => {
    const { sundayReportDetails, ...other } = value;
    return Object.assign(other, { ...sundayReportDetails });
  });
  return {
    totalCount: reportData.totalCount,
    grandTotal: reportData.grandTotal,
    lastSyncDate: reportData?.lastSyncDate,
    items,
  };
};

const mapDatesToColumnFormat = (dates: { [key: string]: string }) => {
  const keys = Object.keys(dates);

  if (keys.length === 0) return [];

  const formattedDates = keys.map((key) => ({
    date: key,
    billing: dates[key],
  }));

  return formattedDates.sort((a, b) => moment(a.date).diff(b.date));
};

export { getDynamicColumnsReportFormattedValues, mapDatesToColumnFormat };
